import { PeriodTypes } from '../../lib/types/models/period/period'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type AvailabilityPeriodInput = {
  startDate: string
  endDate: string
}

export function getPeriodByAvailability(input: AvailabilityPeriodInput) {
  return restApiClient
    .url(
      encodeNestedObject<AvailabilityPeriodInput>(
        constructApiUrl(API.periods.availability.url, null),
        input
      )
    )
    .get<PeriodTypes.Full | undefined>()
}

export function getPeriodsByAvailability(input: AvailabilityPeriodInput) {
  return restApiClient
    .url(
      encodeNestedObject<AvailabilityPeriodInput>(
        constructApiUrl(API.periods.availabilities.url, null),
        input
      )
    )
    .get<PeriodTypes.Full[]>()
}
